// The application entry point. Vite looks for this file because
// index.html references it: <script type="module" src="/src/main.jsx">.
// This is where React takes over the empty <div id="root"> from index.html.

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App.jsx';
import { ErrorBoundary } from './ErrorBoundary.jsx';

// Catch any uncaught render error in any descendant. Without this, React
// 18 production builds emit a "digest" log and unmount the app — the
// user sees a blank screen / gets bounced to login.
ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <App/>
  </ErrorBoundary>
);

// Catch async errors that don't bubble through React (network failures,
// rejected promises) and surface them in the console with extra context
// so we can find them post-mortem.
window.addEventListener('unhandledrejection', (e) => {
  console.error('[unhandledrejection]', e.reason);
});
window.addEventListener('error', (e) => {
  console.error('[window.error]', e.error || e.message);
});
